import React from 'react';
import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';

interface BakeasyHeadingValueProps {
  heading: string;
  value?: any;
  linkUrl?: string;
  bold?: boolean;
  startIcon?: any;
  fontWeight?: number;
  fontSize?: any;
}

const BakeasyLargeHeadingValue: React.FC<BakeasyHeadingValueProps> = ({ heading, value }) => {
  return (
    <Grid container sx={{ display: 'flex' }}>
      <Typography sx={{ fontWeight: '600' }}>{t(`${heading}` + ' \u00A0')}</Typography>
      <Typography> {': \u00A0' + `  ${value}`} </Typography>
    </Grid>
  );
};

export const BakeasyLargeHeadingStatus: React.FC<BakeasyHeadingValueProps> = ({
  heading,
  value
}) => {
  return (
    <Grid container sx={{ display: 'flex' }}>
      <Typography sx={{ fontWeight: '600' }}>{t(`${heading}` + ' \u00A0')}</Typography>
      <Typography>
        {': \u00A0'} {value}
      </Typography>
    </Grid>
  );
};

export default BakeasyLargeHeadingValue;
